// get cookie

export default {
  get(name) {
    let cookieValue = null
    if (document.cookie && document.cookie !== '') {
      let cookies = document.cookie.split(';')
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim()
        if (cookie.substring(0, name.length + 1) === (name + '=')) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
          break
        }
      }
    }
    return cookieValue
  },

  set(name, val, domain) {
    document.cookie = ` ${name}=${val}; domain=${domain};`
  },

  debug(obj, domain) {
    if (typeof obj === 'string' || (obj = obj.payToken)) {
      this.set('payToken', obj, domain)
    } else if (typeof obj === 'object') {
      Object.keys(obj).forEach(key => {
        this.set(key, obj[key], domain)
      })
    }
  }
}
